/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_SettingsInputs */

const en_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Settings`)
};

const es_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de cuenta`)
};

const fr_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres du compte`)
};

const de_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoeinstellungen`)
};

const ja_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント設定`)
};

const zh_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账号设置`)
};

const ar_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعدادات الحساب`)
};

const id_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan Akun`)
};

const it_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni Account`)
};

const ru_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки аккаунта`)
};

const pt_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações da Conta`)
};

const ko_account_settings = /** @type {(inputs: Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 설정`)
};

/**
* | output |
* | --- |
* | "Account Settings" |
*
* @param {Account_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const account_settings = /** @type {((inputs?: Account_SettingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_SettingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_account_settings(inputs)
	if (locale === "es") return es_account_settings(inputs)
	if (locale === "fr") return fr_account_settings(inputs)
	if (locale === "de") return de_account_settings(inputs)
	if (locale === "ja") return ja_account_settings(inputs)
	if (locale === "zh") return zh_account_settings(inputs)
	if (locale === "ar") return ar_account_settings(inputs)
	if (locale === "id") return id_account_settings(inputs)
	if (locale === "it") return it_account_settings(inputs)
	if (locale === "ru") return ru_account_settings(inputs)
	if (locale === "pt") return pt_account_settings(inputs)
	return ko_account_settings(inputs)
});